var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { commonCSS } from "../common";
import { mainStyles, h1, h2, h3, h4, h5, h6 } from "./styles";
var H1Style = styled.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n"])), mainStyles, commonCSS, h1);
var H2Style = styled.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n"])), mainStyles, commonCSS, h2);
var H3Style = styled.h3(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n"])), mainStyles, commonCSS, h3);
var H4Style = styled.h4(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n"])), mainStyles, commonCSS, h4);
var H5Style = styled.h5(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n"])), mainStyles, commonCSS, h5);
var H6Style = styled.h6(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n"])), mainStyles, commonCSS, h6);
export var H1 = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(H1Style, __assign({}, props), children);
};
export var H2 = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(H2Style, __assign({}, props), children);
};
export var H3 = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(H3Style, __assign({}, props), children);
};
export var H4 = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(H4Style, __assign({}, props), children);
};
export var H5 = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(H5Style, __assign({}, props), children);
};
export var H6 = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(H6Style, __assign({}, props), children);
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
